module.exports = __webpack_public_path__ + "static/media/icon_mg07s.90d874ea.svg";